export default "__VITE_ASSET__d9eac300__"